import { motion } from 'framer-motion';

interface ScreensaverProps {
  /**
   * Ha meg van adva, a videó tölti ki a hátteret (pl. bazilika-felvétel).
   * Amíg nincs valódi felvétel feltöltve, marad `undefined`, és az animált
   * gradiens placeholder jelenik meg helyette.
   */
  videoSrc?: string;
}

export function Screensaver({ videoSrc }: ScreensaverProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden"
    >
      {videoSrc ? (
        <video
          src={videoSrc}
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-kiosk-accent-soft via-kiosk-bg to-kiosk-accent2 bg-[length:200%_200%] animate-screensaver-gradient" />
      )}

      {/* Glassmorph panel: a háttér (gradiens/videó) átszűrődik, de a szöveg a panel saját
          kontrasztja miatt mindig olvasható marad, függetlenül attól, mi van alatta. */}
      <motion.div
        initial={{ scale: 0.92, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.15, ease: 'easeOut' }}
        className="relative z-10 flex flex-col items-center gap-4 kiosk:gap-[2.6vw] text-center mx-6 px-8 py-10 kiosk:mx-0 kiosk:px-[6vw] kiosk:py-[5vw] rounded-3xl kiosk:rounded-[3vw] bg-white/20 backdrop-blur-2xl border border-white/40 shadow-2xl shadow-black/20"
      >
        <div className="font-display text-kiosk-xl font-extrabold tracking-wide text-kiosk-text">
          VisitKiosk
        </div>
        <motion.div
          animate={{ scale: [1, 1.12, 1] }}
          transition={{ duration: 1.8, repeat: Infinity, ease: 'easeInOut' }}
          className="text-5xl kiosk:text-[6vw] leading-none"
          aria-hidden="true"
        >
          👆
        </motion.div>
        <p className="font-display text-kiosk-base text-kiosk-text/90">
          Koppints a kezdéshez
        </p>
      </motion.div>
    </motion.div>
  );
}
